import React, { useCallback, useEffect, useRef, useState } from "react";
import { Directon } from "../../../../enums/direction";
import useAutoScroll from "../../../../hooks/useAutoScroll";
import Scroll from "../../scroll/Scroll";
import classes from "./ScrollShadow.module.css";

const ScrollShadow = ({ widgetColor, children ,autoScroll=false}) => {
    const targetRef = useRef(null);
    const [isUp, setIsUp] = useState(false);
    const [isDown, setIsDown] = useState(false);

    const update = useCallback((ref) => {
        if (!ref)
            return;
        const { scrollTop, scrollHeight, clientHeight } = ref;
        setIsUp(Math.floor(scrollTop) > 0);
        setIsDown(Math.ceil(scrollTop + clientHeight) < Math.floor(scrollHeight) - 1);
    }, []);

    const step = useCallback((ref, dir) => {
        if (!ref)
            return;
        const s = Math.max(60, Math.floor(ref.clientHeight * 0.5));
        const maxTop = ref.scrollHeight - ref.clientHeight;
        const next = dir === Directon.down ? Math.min(ref.scrollTop + s, maxTop) : Math.max(ref.scrollTop - s, 0);
        ref.scrollTo({ top: next, behavior: "smooth" });
    }, []);

    const onScroll = useCallback((e) => {
        const ref = e.target;
        update(ref);
        requestAnimationFrame(() => update(ref));
    }, [update]);

    useEffect(() => {
        const ref = targetRef?.current;
        if (!ref)
            return;
        ref.addEventListener("scroll", onScroll, { passive: true });
        update(ref)
        const timer = setTimeout(() => {
            update(ref);
            requestAnimationFrame(() => update(ref));
        }, 150);

        return () => {
            ref.removeEventListener("scroll", onScroll);
            clearTimeout(timer);
        };
    }, [targetRef, onScroll, update]);

    const onClickScroll = (e, dir, ref) => {
        e.stopPropagation();
        step(ref.current, dir)
    }

    useAutoScroll(targetRef, {
        speed:0.5, 
        interval: 30,     
        enabled:autoScroll,
        onAfterScroll: update,
    });

    return (
        <div className={classes.scrollWrapper} style={{ "--scroll-base-color": widgetColor }}>
            {isUp && (
                <button className={classes.shadow} onClick={(e) => onClickScroll(e, Directon.top, targetRef)} />
            )}
            <Scroll ref={targetRef} height={"100%"} showDots={true}>
                {children}
            </Scroll>

            {isDown && (
                <div className={classes.ScrollHint} onClick={(e) => onClickScroll(e, Directon.down, targetRef)} />
            )}
        </div>
    )
}

export default ScrollShadow;
